const Error =()=>{
    return(
        <main className="error-main" id="errorMain">
            <div className="container">
                <img src="/images/bookshelf.jpg" alt="placeholder img" className="img-fluid image d-block mx-auto" />
                    <p className="error-text text-center">This page does not exist</p>
            </div>
        </main> 
    )
}

export default Error